import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "../../basic-features/banner/banner.component";
import * as i2 from "@angular/common";
function PageLayoutComponent_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelementContainer(1, 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const defaultSidebarTemplate_r2 = i0.ɵɵreference(19);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.sidebarTemplate || defaultSidebarTemplate_r2);
  }
}
function PageLayoutComponent_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " PLEASE PROVIDE A HEADER TEMPLATE ");
  }
}
function PageLayoutComponent_ng_template_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0, " PLEASE PROVIDE A CONTENT TEMPLATE ");
  }
}
function PageLayoutComponent_ng_template_16_Template(rf, ctx) {}
function PageLayoutComponent_ng_template_18_Template(rf, ctx) {}
export class PageLayoutComponent {
  headerTemplate;
  contentTemplate;
  footerTemplate;
  sidebarTemplate;
  ngOnInit() {
    if (!this.headerTemplate) {
      // eslint-disable-next-line no-console
      console.error(`providing a header template is mandatory. Example code:
            <geaui-page-layout [headerTemplate]="header">
                <ng-template #header>
                    <geaui-header [noAuth]="true" [headerTitle]="title"></geaui-header>
                </ng-template>
            </geaui-page-layout>
      `);
    }
    if (!this.contentTemplate) {
      // eslint-disable-next-line no-console
      console.error(`providing a content template is mandatory \r\n \r\n
            <geaui-page-layout [contentTemplate]="content">
              <ng-template #content>
                <router-outlet></router-outlet>
              </ng-template>
            </geaui-page-layout>
      `);
    }
  }
  static ɵfac = function PageLayoutComponent_Factory(t) {
    return new (t || PageLayoutComponent)();
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: PageLayoutComponent,
    selectors: [["geaui-page-layout"]],
    inputs: {
      headerTemplate: "headerTemplate",
      contentTemplate: "contentTemplate",
      footerTemplate: "footerTemplate",
      sidebarTemplate: "sidebarTemplate"
    },
    decls: 20,
    vars: 4,
    consts: [["defaultHeaderTemplate", ""], ["defaultContentTemplate", ""], ["defaultFooterTemplate", ""], ["defaultSidebarTemplate", ""], [1, "geaui-page-layout-container"], [1, "geaui-page-layout-north"], [3, "ngTemplateOutlet"], [1, "geaui-page-layout-south"], ["class", "geaui-page-layout-left-sidebar", 4, "ngIf"], [1, "geaui-page-layout-center"], [1, "geaui-page-layout-banner"], ["id", "geaui-page-layout-content", "data-cy", "page-content", 1, "geaui-page-layout-content"], [1, "geaui-page-layout-footer"], [1, "geaui-page-layout-left-sidebar"]],
    template: function PageLayoutComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 4)(1, "header", 5);
        i0.ɵɵelementContainer(2, 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 7);
        i0.ɵɵtemplate(4, PageLayoutComponent_div_4_Template, 2, 1, "div", 8);
        i0.ɵɵelementStart(5, "main", 9)(6, "div", 10);
        i0.ɵɵelement(7, "geaui-banner");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 11);
        i0.ɵɵelementContainer(9, 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "div", 12);
        i0.ɵɵelementContainer(11, 6);
        i0.ɵɵelementEnd()()()();
        i0.ɵɵtemplate(12, PageLayoutComponent_ng_template_12_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(14, PageLayoutComponent_ng_template_14_Template, 1, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(16, PageLayoutComponent_ng_template_16_Template, 0, 0, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(18, PageLayoutComponent_ng_template_18_Template, 0, 0, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
      }
      if (rf & 2) {
        const defaultHeaderTemplate_r3 = i0.ɵɵreference(13);
        const defaultContentTemplate_r4 = i0.ɵɵreference(15);
        const defaultFooterTemplate_r5 = i0.ɵɵreference(17);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.headerTemplate || defaultHeaderTemplate_r3);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.sidebarTemplate);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate || defaultContentTemplate_r4);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.footerTemplate || defaultFooterTemplate_r5);
      }
    },
    dependencies: [i1.BannerComponent, i2.NgTemplateOutlet, i2.NgIf],
    styles: [".geaui-page-layout-container[_ngcontent-%COMP%]{height:100vh;display:flex;flex-direction:column}.geaui-page-layout-container[_ngcontent-%COMP%]   .geaui-page-layout-south[_ngcontent-%COMP%]{flex:1;display:flex;overflow-y:auto}.geaui-page-layout-container[_ngcontent-%COMP%]   .geaui-page-layout-south[_ngcontent-%COMP%]   .geaui-page-layout-center[_ngcontent-%COMP%]{flex:1;display:flex;flex-direction:column}.geaui-page-layout-container[_ngcontent-%COMP%]   .geaui-page-layout-south[_ngcontent-%COMP%]   .geaui-page-layout-center[_ngcontent-%COMP%]   .geaui-page-layout-content[_ngcontent-%COMP%]{flex:1;overflow-y:auto}"]
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(PageLayoutComponent, [{
    type: Component,
    args: [{
      selector: 'geaui-page-layout',
      template: "<div class=\"geaui-page-layout-container\">\n  <header class=\"geaui-page-layout-north\">\n    <ng-container [ngTemplateOutlet]=\"headerTemplate || defaultHeaderTemplate\"></ng-container>\n  </header>\n  <div class=\"geaui-page-layout-south\">\n    <div class=\"geaui-page-layout-left-sidebar\" *ngIf=\"sidebarTemplate\">\n      <ng-container [ngTemplateOutlet]=\"sidebarTemplate || defaultSidebarTemplate\"></ng-container>\n    </div>\n    <main class=\"geaui-page-layout-center\">\n      <div class=\"geaui-page-layout-banner\">\n        <geaui-banner></geaui-banner>\n      </div>\n      <div class=\"geaui-page-layout-content\" id=\"geaui-page-layout-content\" data-cy=\"page-content\">\n        <ng-container [ngTemplateOutlet]=\"contentTemplate || defaultContentTemplate\"></ng-container>\n      </div>\n      <div class=\"geaui-page-layout-footer\">\n        <ng-container [ngTemplateOutlet]=\"footerTemplate || defaultFooterTemplate\"></ng-container>\n      </div>\n    </main>\n  </div>\n</div>\n<ng-template #defaultHeaderTemplate> PLEASE PROVIDE A HEADER TEMPLATE </ng-template>\n<ng-template #defaultContentTemplate> PLEASE PROVIDE A CONTENT TEMPLATE </ng-template>\n<ng-template #defaultFooterTemplate></ng-template>\n<ng-template #defaultSidebarTemplate></ng-template>\n",
      styles: [".geaui-page-layout-container{height:100vh;display:flex;flex-direction:column}.geaui-page-layout-container .geaui-page-layout-south{flex:1;display:flex;overflow-y:auto}.geaui-page-layout-container .geaui-page-layout-south .geaui-page-layout-center{flex:1;display:flex;flex-direction:column}.geaui-page-layout-container .geaui-page-layout-south .geaui-page-layout-center .geaui-page-layout-content{flex:1;overflow-y:auto}\n"]
    }]
  }], null, {
    headerTemplate: [{
      type: Input
    }],
    contentTemplate: [{
      type: Input
    }],
    footerTemplate: [{
      type: Input
    }],
    sidebarTemplate: [{
      type: Input
    }]
  });
})();
